module.exports = __webpack_public_path__ + "static/DSC_7317-1bcdfd03b2725a2f0044919ffc8ddad2.jpg";